
import React, { useMemo, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import useUtils from '../../../utiles/useUtiles';

const SubscriptionsContent: React.FC = () => {

    const [usersList, setUsersList] = useState<any>({ count: 0, rows: [] });
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [searchText, setSearchText] = useState<string>('');
    const [pagination, setPagination] = useState<any>({
        pageIndex: 0,
        pageSize: 10
    });
    const { axiosRequest, toastInstance, loadingScreen, currencyFormat } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect(() => {
        fetchUsers();
    }, [pagination.pageIndex, pagination.pageSize]);


    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }: any) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'email',
                header: 'Email',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'amount',
                header: 'Amount	',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <span>{currencyFormat(cell.getValue(), 'USA')}</span>,
            },
            {
                accessorKey: 'attempts',
                header: 'Attempts',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'nextCharge',
                header: 'Next Charge',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'daysUntilCharge',
                header: 'Days until next charge',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <div className='text-center'>{cell.getValue()}</div>,
            },
        ],
        [],
    );

    const fetchUsers = async () => {
        try {
            setLoading(true);
            let queryString = `page=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
            if (searchText) {
                queryString += `&email=${searchText}`;
            }
            const request = await axios.get(`propelrpay/get_list_of_subscriptions?${queryString}`);
            const { error, count, rows } = request.data.result;
            setLoading(false);
            if (error) throw new Error('Error to fetch subscriptions');
            setUsersList({ count: count, rows: rows });
        } catch (error) {
            setLoading(false);
            toast.error('Error occurred while fetching subscriptions');
        }
    };


    return (
        <>
            <div className='mb-4 row'>
                <div className='col-md-10'>
                    <input type={"text"} name="searchText" placeholder="Email" className="form-control" autoComplete='new-password' onChange={(e) => setSearchText(e.target.value)} />
                </div>
                <div className='col-md-2'>
                    <button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchUsers}>Search</button>
                </div>
            </div>
            <MaterialReactTable
                columns={columns}
                data={usersList?.rows}
                rowCount={usersList?.count}
                enableColumnOrdering={false}
                enableRowSelection={false}
                enableSelectAll={false}
                enableColumnActions={false}
                manualPagination
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableSorting={false}
                enableGlobalFilter={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableHiding={false}
                enableColumnFilters
                enableFilters={false}
            />
            {loadingScreen(loading)}
        </>
    );
}

export default SubscriptionsContent;